var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.33,
    height: 14.785,
    viewBox: "0 0 17.33 14.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "racing",
    transform: "translate(0 -37.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(9.09 44.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M269.4,230.954a.848.848,0,1,0,.848.848A.849.849,0,0,0,269.4,230.954Z",
    transform: "translate(-268.555 -230.954)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(10.499 41.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M310.189,155.037v1.529a1.978,1.978,0,0,1,1.061.771l1.454-.472A3.473,3.473,0,0,0,310.189,155.037Z",
    transform: "translate(-310.189 -155.037)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(11.502 44.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M341.663,240.574l-1.454.473c0,.017,0,.033,0,.05a1.96,1.96,0,0,1-.407,1.2l.9,1.236a3.462,3.462,0,0,0,.962-2.955Z",
    transform: "translate(-339.803 -240.574)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(0 37.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M9.938,37.6H3.107a.561.561,0,1,0,0,1.123H6.025a7.447,7.447,0,0,0-1.648,1.4H.561a.562.562,0,0,0,0,1.123h3A7.378,7.378,0,0,0,3.9,49.26H2.312a.561.561,0,0,0,0,1.123H4.885a7.439,7.439,0,0,0,1.141.879H.619a.561.561,0,1,0,0,1.123H9.938a7.392,7.392,0,1,0,0-14.785Zm2.727,11.077-.032.026-.038.026a4.577,4.577,0,0,1-5.315,0L7.242,48.7l-.032-.026a4.586,4.586,0,1,1,5.455,0Z",
    transform: "translate(0 -37.6)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(6.862 41.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M202.722,156.864l1.454.472a1.978,1.978,0,0,1,1.061-.771v-1.529A3.473,3.473,0,0,0,202.722,156.864Z",
    transform: "translate(-202.722 -155.036)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(8.384 46.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M249.9,310.894a1.966,1.966,0,0,1-1.312,0l-.9,1.236a3.458,3.458,0,0,0,3.108,0Z",
    transform: "translate(-247.685 -310.894)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(6.475 44.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M192.776,241.1c0-.017,0-.033,0-.05l-1.454-.473a3.462,3.462,0,0,0,.962,2.955l.9-1.236A1.961,1.961,0,0,1,192.776,241.1Z",
    transform: "translate(-191.283 -240.574)",
    fill: "current"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrders);
export default __webpack_public_path__ + "static/media/my_orders.daa4320d86b8a8a8e3534d29cb8d4c6c.svg";
export { ForwardRef as ReactComponent };